import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';
import ActiveBonusesControllerImpl from './active-bonuses-controller.js';
import PropTypes from 'prop-types';

/**
 * Component responsible for managing the presentation of active bonuses.
 *
 * @name Controller
 * @class ActiveBonusesController
 * @memberof Mojito.Modules.ActiveBonuses
 */

/**
 * `ActiveBonusesController` prop types.
 *
 * @property {boolean} [showPrewager = true] - Indicates whether the prewager should be displayed or not.
 * @property {boolean} [showOddsBoosts = true] - Indicates whether the odds boosts should be displayed or not.
 * @property {Function} [onContentLoad = () => {}] - Callback called when active bonuses content has loaded. Accepts boolean to indicate if there are any bonuses.
 *
 * @memberof Mojito.Modules.ActiveBonuses.Controller
 */
const propTypes = {
    showPrewager: PropTypes.bool,
    showOddsBoosts: PropTypes.bool,
    onContentLoad: PropTypes.func,
};

const defaultProps = {
    showPrewager: true,
    showOddsBoosts: true,
    onContentLoad: noop,
};

export default MojitoCore.Presentation.UIControllerView(
    'ActiveBonusesController',
    ActiveBonusesControllerImpl,
    propTypes,
    defaultProps
);
